import React from 'react';

const UniRadioItem = (props) => {
  let name = props.name;
  let value = props.value;  // licni value od bas ovog radio itema
  let title = props.title;
  let tooltip = null;
  if (typeof props.tooltip === 'string' && props.tooltip !== '') {
    tooltip = props.tooltip;
  }

  let formState = props.formState;
  let handleChange = props.handleChange;

  let chosen_value = formState[name]; // value iz radios grupe
  let checked = false;
  if (value === chosen_value) {
    checked = true;
  }


  return (
    <label className="uniformcompo__label-wrapping-checkbox" htmlFor={name}>
      <span className="label">
        {
          tooltip ? (<abbr title={tooltip}>{title}</abbr>) : (title)
        }
      </span>
      <span className="uu-anyinput__control-container uniformcompo__checkbox-aura">
        <input
          type="radio"
          name={name}
          value={value}
          checked={checked}
          onChange={handleChange}
          className="uu-anyinput-control-radio"
        />
      </span>
    </label>
  );
}

export default UniRadioItem;

/*
Kako se dobijada li je radio checked?

name="visina" value="patuljast"
name="visina" value="nizak"
name="visina" value="srednji"
name="visina" value="visok"
*/